import {Entity} from '@s-ui/domain'

export class FinancingConditionEntity extends Entity {
  /**
   * @param {Object} data
   * @param {Boolean} data.availableTerm
   * @param {Boolean} data.availableTerms
   * @param {Date} data.dateFirstInstallment
   * @param {Date} data.dateSignup
   * @param {Number} data.capital
   * @param {Number} data.cashPrice
   * @param {Number} data.coefficient
   * @param {Number} data.commission
   * @param {Number} data.commissionEur
   * @param {Number} data.fareInsuranceId
   * @param {Number} data.fee
   * @param {Number} data.financedPrice
   * @param {Number} data.firstFee
   * @param {Boolean} data.hasSpecificLegalConditions
   * @param {Number} data.insuranceCoverages
   * @param {Number} data.insuranceId
   * @param {Number} data.insuranceName
   * @param {Number} data.insuranceRate
   * @param {Boolean} data.isOpeningExpensesFinanced
   * @param {Number} data.lender
   * @param {Number} data.lenderLegalTextId
   * @param {Number} data.licenseWithdrawalInsuranceAmount
   * @param {Number} data.lifeInsuranceAmount
   * @param {Number} data.loanRequestAvailable
   * @param {Number} data.maxEntry
   * @param {Number} data.maxEntryToGetDiscount
   * @param {Number} data.minEntry
   * @param {Number} data.openingExpenses
   * @param {Number} data.openingPercentage
   * @param {Number} data.tae
   * @param {Number} data.terms
   * @param {String} data.termsUrl
   * @param {Number} data.tin
   * @param {Number} data.totalInterest
   * @param {String} data.id
   * @param {String} data.lender
   * @param {String} data.selectedOption
   * @param {Number} data.totalAmountDue
   * @param {Number} data.totalLoanAmount
   * @param {Number} data.totalLoanCost
   * @param {Number} data.totalPriceTerms
   * @param {Number} data.totalTermsAmount
   * @param {Date} data.dateOfferEnd
   *
   */

  hasFinancingData() {
    return Boolean(this._id)
  }

  static validateLegalTextId({lender, lenderLegalTextId, validateError}) {
    const isValid = lenderLegalTextId !== null && lenderLegalTextId.includes(lender)
    if (!isValid) throw validateError('lenderLegalTextId is not valid')
  }
}
